
const main_config = {
    title: "Emil Nicolaie Perhinschi"
}

export default Object.freeze(main_config)



// WEBPACK FOOTER //
// ./src/lib/config/main.js